/**
 * TableLink Component
 *
 * A styled link for use within data tables.
 * Uses the primary cyan color and stops event propagation.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { colors, typography as typographyTokens } from '../../tokens';

export interface TableLinkProps {
    /** Link destination */
    to: string;
    /** Link text */
    children: React.ReactNode;
    /** Click handler */
    onClick?: (e: React.MouseEvent) => void;
}

export const TableLink: React.FC<TableLinkProps> = ({ to, children, onClick }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClick?.(e);
    };

    return (
        <Link
            to={to}
            onClick={handleClick}
            style={{
                color: colors.primary[500],
                textDecoration: 'none',
                fontWeight: typographyTokens.fontWeight.medium,
                fontSize: typographyTokens.fontSize.sm,
            }}
        >
            {children}
        </Link>
    );
};

export default TableLink;

